import Vue from 'vue';
import Router from 'vue-router';

import Home from './views/Home.vue';
import Login from './views/Login.vue';
import UserConfigInfo from './views/UserConfigInfo.vue';
import AccountManager from './views/AccountManager.vue';

// import AccountWizard from './components/AccountWizard.vue';
import Report from './views/Report.vue';
import SaleReport from './components/report/SaleReport.vue';
import BetReport from './components/report/BetReport.vue';
import BetReportRaw from './components/report/BetReportRaw.vue';
import BetReportDetail from './components/report/BetReportDetail.vue';
import BetReportTotal from './components/report/BetReportTotal.vue';
import IncrCommission from './components/tools/IncrCommission.vue';
import AutoCommission from './components/tools/AutoCommission.vue';
import DailyCommission from './components/tools/DailyCommission.vue';
import DailyLockNumber from './components/tools/DailyLockNumber.vue';
import CountTrialAndPayCustomer from './components/tools/CountTrialAndPayCustomer.vue';
import BettedRatio from './components/tools/BettedRatio.vue';
import LockNumber from './components/tools/LockNumber.vue';
import GameResult from './components/GameResult.vue';
import MainAccountList from './components/account/MainAccountList.vue';
import SubAccountList from './components/account/SubAccountList.vue';
import AccountList from './components/account/AccountList.vue';
import AccountInfoForm from './components/account/AccountInfoForm.vue';
import Notify from './views/Notify.vue';
import Logs from './views/Logs.vue';
import Partner from './views/Partner.vue';
import RemovePartnerExtend from './components/partner/RemovePartnerExtend.vue';
import HighRateNumber from './components/tools/HighRateNumber.vue';
import RemoveDevice from './components/tools/RemoveDevice.vue';
import ChangeDevice from './components/tools/ChangeDevice.vue';
import FindUserCode from './components/tools/FindUserCode.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'LoginPage',
      component: Login
    },    
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        { path: 'user-info', name: 'UserInfo', component: UserConfigInfo },
        { path: 'notify', name: 'Notify', component: Notify },
        { path: 'logs', name: 'Logs', component: Logs },
        { 
          path: 'account', name: 'AccountManager', component: AccountManager, redirect: 'account/main',
          children: [
            { path: 'main', name: 'MainAccountList', component: MainAccountList,
              children: [
                { path: 'edit/:code', name: 'EditAccount', component: AccountInfoForm },
                { path: 'create/:role', name: 'CreateAccount', component: AccountInfoForm },
                { path: ':code', name: 'AccountList', component: AccountList },
                { path: '', name: 'AccountListRoot', component: AccountList },
              ]
            },
            { path: 'clone', name: 'SubAccountList', component: SubAccountList },
          ]
        },
        { 
          path: 'report', name: 'Report', component: Report, redirect: 'report/bet',
          children: [
            { path: 'sale', name: 'SaleReport', component: SaleReport, props: { rptype: 'sale' }},
            { path: 'bet', name: 'BetReport', component: BetReport, props: { rptype: 'winloss' },
              children: [
                  { path: ':code/:smsId', name: 'BetReportDetail', component: BetReportDetail },
                  { path: ':code', name: 'BetReportTotal', component: BetReportTotal }
                ]
            },
            { path: 'bet-raw', name: 'BetReportRaw', component: BetReportRaw, props: { rptype: 'raw' },
              children: [
                  { path: ':code/:smsId', name: 'BetReportDetailRaw', component: BetReportDetail },
                  { path: ':code', name: 'BetReportTotalRaw', component: BetReportTotal }
                ]
            },
            { path: 'thong-ke-so', name: 'BettedRatio', component: BettedRatio },
          ]
        },
        { 
          path: 'tools', name: 'Tools', component: Report, redirect: 'tools/commission',
          children: [
            { path: 'game-result', name: 'GameResult', component: GameResult },
            { path: 'commission', name: 'IncrCommission', component: IncrCommission },
            { path: 'lock-number', name: 'LockNumber', component: LockNumber },
            { path: 'auto-commission', name: 'AutoCommission', component: AutoCommission },
            { path: 'daily-commission', name: 'DailyCommission', component: DailyCommission },
            { path: 'daily-locknumber', name: 'DailyLockNumber', component: DailyLockNumber },
            { path: 'high-rate-number', name: 'HighRateNumber', component: HighRateNumber },
            { path: 'count-pay-trial', name: 'CountTrialAndPayCustomer', component: CountTrialAndPayCustomer },
            { path: 'change-device', name: 'ChangeDevice', component: ChangeDevice },
            { path: 'remove-device', name: 'RemoveDevice', component: RemoveDevice },
            { path: 'find-user-code', name: 'FindUserCode', component: FindUserCode },
          ]
        },
        { 
          path: 'partner', name: 'Partner', component: Partner, redirect: 'partner/remove-extend',
          children: [
            { path: 'remove-extend', name: 'RemovePartnerExtend', component: RemovePartnerExtend }
          ]
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('token');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
})
